import { Skeleton } from "@mui/material";
import { type FC } from "react";

import * as Styled from "./Categories.styles";

const CATEGORY_WIDTHS = [62, 94, 98, 112, 90, 78, 120, 86, 104, 74];
const CATEGORY_HEIGHT = 43;

export const CategoriesSkeleton: FC = () => {
  return (
    <Styled.Root>
      <Styled.Container sx={{ overflow: "hidden" }}>
        {CATEGORY_WIDTHS.map((width, index) => (
          <Styled.CategoryWrapper key={index}>
            <Skeleton
              variant="rounded"
              width={width}
              height={CATEGORY_HEIGHT}
              sx={{ flexShrink: 0 }}
            />
          </Styled.CategoryWrapper>
        ))}
      </Styled.Container>
    </Styled.Root>
  );
};
